export const FETCH_DOCTORS_LIST_REQUEST = "FETCH_DOCTORS_LIST_REQUEST";
export const FETCH_DOCTORS_LIST_SUCCESS = "FETCH_DOCTORS_LIST_SUCCESS";
export const FETCH_DOCTORS_LIST_FAILURE = "FETCH_DOCTORS_LIST_FAILURE";